// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_i0-a";
export var fulfillmentFormRail = "_i0-9";
export var headerTitleRow = "_i0-c";
export var orderDetailsWrapper = "_i0-7";
export var orderLinkTrigger = "_i0-2";
export var paymentInformationGrid = "_i0-h";
export var paymentSummaryColumn = "_i0-i";
export var shipmentContainer = "_i0-b";
export var shipmentDetailsMainPane = "_i0-8";
export var shipmentNavigationCard = "_i0-5";
export var shipmentNavigationRail = "_i0-3";
export var shipmentNavigationRailHeader = "_i0-4";
export var shipmentSummaryFact = "_i0-e";
export var shipmentSummaryGrid = "_i0-d";
export var shipmentSummaryMetadataRow = "_i0-f";
export var shipmentSummaryTags = "_i0-g";
export var shipmentWorkspace = "_i0-0";
export var shipmentWorkspaceContent = "_i0-6";
export var shipmentWorkspaceHeader = "_i0-1";